import { FormField } from "@/components/common/form-field";
import { EinField, PhoneField } from "@/components/common/masked-form-field";
import {
  type TabProps,
  useBlurSave,
} from "@/features/portal/components/onboarding/tabs/tab-shared";

/** Business Information tab (business clients). */
export function BusinessTab({ save }: TabProps) {
  const onBlur = useBlurSave(save);
  return (
    <div className="grid gap-6">
      <div className="grid gap-4 sm:grid-cols-2">
        <FormField name="business_name" label="Business Name" onBlur={onBlur("business_name")} />
        <FormField name="dba" label="DBA (Doing Business As)" onBlur={onBlur("dba")} />
      </div>

      <div className="sm:max-w-xs">
        <EinField name="ein" label="EIN" onBlur={onBlur("ein")} />
      </div>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        <PhoneField name="work_phone" label="Business Phone" onBlur={onBlur("work_phone")} />
        <PhoneField name="mobile_phone" label="Business Mobile" onBlur={onBlur("mobile_phone")} />
        <PhoneField name="fax_number" label="Fax" onBlur={onBlur("fax_number")} />
      </div>
    </div>
  );
}
